import { ProjectLayoutMapper } from 'mapper/ProjectLayoutMapper';

export const projectLayoutMapper = new ProjectLayoutMapper();
